import type { ReactNode } from "react";

type AiAssistantExpandableButtonProps = {
  children: ReactNode;
  onClick: () => void;
};

const AiAssistantExpandableButton = ({
  children,
  onClick,
}: AiAssistantExpandableButtonProps) => (
  <div
    onClick={onClick}
    className="flex items-center gap-1 text-xs text-text-secondary -ml-1 px-1 rounded-sm leading-8! cursor-pointer select-none hover:text-text-primary hover:bg-action-hover"
    data-test-id="ai-assistant-expandable-button"
  >
    {children}
  </div>
);

export default AiAssistantExpandableButton;
